// extracted by mini-css-extract-plugin
export var storyblokLink = "storyblok-link-module--storyblok-link--f8af6";